import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { DownloadedFile } from 'src/models';

import { PdfFileViewer } from '../PdfFileViewer/PdfFileViewer';

export const FileViewerModal = ({ file, onClose }: { file: DownloadedFile; onClose: () => void }) => {
  const renderPdfFile = () => {
    return <PdfFileViewer url={file.url} />;
  };

  const renderImageFile = () => {
    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <img src={file.url} />
      </div>
    );
  };

  const renderUnknownFileTypeError = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <p>Error opening the file. Received unknown file type: {file.type}</p>
    </div>
  );

  const renderContent = () => {
    if (file.type === 'pdf') {
      return renderPdfFile();
    }

    if (file.type === 'image') {
      return renderImageFile();
    }

    return renderUnknownFileTypeError();
  };

  return (
    <Dialog open onClose={onClose} fullScreen>
      <DialogContent>{renderContent()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary' variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
